module.exports = __webpack_public_path__ + "static/media/second-quote.cd263eb0.jpg";